export default "__VITE_ASSET__D70F$KwB__"